import React from "react";
import { Leaf, Eye, VolumeX, Handshake } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const icons = [Leaf, Eye, VolumeX, Handshake];

const WhyThisSite = () => {
  const { t } = useLanguage();
  return (
    <section
      className="py-24 lg:py-32 bg-[#FAFAF9]"
      data-testid="why-this-site"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D]">
            {t.why.label}
          </span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-[#202C21] font-semibold">
            {t.why.title}
          </h2>
        </div>

        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5">
          {t.why.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                className="bg-white border border-[rgba(117,148,122,0.15)] rounded-2xl p-7 hover:border-[rgba(117,148,122,0.35)] transition-colors"
                data-testid={`why-item-${i + 1}`}
              >
                <div className="w-10 h-10 rounded-xl bg-[#E6EDE7] flex items-center justify-center">
                  <Icon
                    className="w-4.5 h-4.5 text-[#5F7C63]"
                    strokeWidth={1.75}
                  />
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold tracking-tight text-[#202C21]">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-[#5C6B5D] leading-relaxed">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyThisSite;
